module.exports = __webpack_public_path__ + "img/contrSlope.f0ad7b56.svg";